<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Select } from '@client/components/select';
  import { ShowMore } from '@client/components/show-more';
  import { Switch } from '@client/components/switch';

  export let route = {};
  export let signaturesOptions = [];
  export let groupOptions = [];
  export let tagOptions = [];
  export let filterText = '';
  export let expanded = false;
  export let onSignatureChange = () => {};
  export let addItem = () => {};
</script>

<div class="signature-route-form">
  <div class="section" aria-labelledby="type-label">
    <p id="type-label">
      {$format('label.SIGNATURE')}
      <Icon name="help-circle" id="tooltip-route-signature" />
      <Tooltip target="tooltip-route-signature" placement="top">
        {@html $format('label.TOOLTIP.ROUTE_SIGNATURE')}
      </Tooltip>
    </p>
    <Select
      bind:items={signaturesOptions}
      on:change={onSignatureChange}
      value={route.blockname}
      placeholder={$format('label.PLACEHOLDER.SELECT_SIGNATURE')}
      clearable={false}
      showChevron
    />
  </div>
  <div class="section" aria-labelledby="groups-label">
    <p id="groups-label">
      {$format('label.GROUPS')}
      <Icon name="help-circle" id="tooltip-route-groups" />
      <Tooltip target="tooltip-route-groups" placement="top">
        {$format('label.TOOLTIP.ROUTE_GROUPS')}
      </Tooltip>
    </p>
    <Select
      bind:items={groupOptions}
      bind:value={route.selectedGroups}
      placeholder={$format('label.PLACEHOLDER.SELECT_GROUP')}
      clearable={false}
      multiple
      showChevron
    />
  </div>
  <div class="section" aria-labelledby="status-label">
    <p id="status-label">
      {$format('label.ACTIVE')}
      <Icon name="help-circle" id="tooltip-route-status" />
      <Tooltip target="tooltip-route-status" placement="top">
        {$format('label.TOOLTIP.ROUTE_STATUS')}
      </Tooltip>
    </p>
    <Switch bind:checked={route.status} aria-labelledby="status-label" />
  </div>

  <hr />

  <ShowMore
    bind:expanded
    expandedText={$format('label.HIDE_ADVANCED_OPTIONS')}
    collapsedText={$format('label.SHOW_ADVANCED_OPTIONS')}
  >
    <div class="section pt-3" aria-labelledby="campaigns-label" on:keyup={addItem} role="button" tabindex="0">
      <p id="campaigns-label">
        {$format('label.TAGS')}
        <Icon name="help-circle" id="tooltip-route-tags" />
        <Tooltip target="tooltip-route-tags" placement="top">
          {$format('label.TOOLTIP.ROUTE_TAGS')}
        </Tooltip>
      </p>
      <Select
        bind:items={tagOptions}
        bind:filterText
        bind:value={route.selectedTags}
        on:change={addItem}
        placeholder={$format('label.PLACEHOLDER.SELECT_OR_CREATE_NEW_TAG')}
        clearable={false}
        multiple
        showChevron
        searchable
      >
        <slot name="empty" slot="empty">
          <div class="empty">
            {#if !filterText.length}
              {$format('label.START_TYPING_TO_SEARCH_TAGS')}
            {:else if route.selectedTags?.map(({ value }) => value).includes(filterText)}
              {$format('label.TAG_ALREADY_EXISTS')}
            {:else}
              {@html $format('label.PRESS_ENTER_TO_CREATE_TAG', { values: { item: filterText } })}
            {/if}
          </div>
        </slot>
      </Select>
    </div>
    <div class="section" aria-labelledby="hide-label">
      <p id="hide-label">
        {$format('label.HIDE_FROM_ADDIN')}
        <Icon name="help-circle" id="tooltip-route-hidden" />
        <Tooltip target="tooltip-route-hidden" placement="top">
          {$format('label.TOOLTIP.HIDE_FROM_ADDIN')}
        </Tooltip>
      </p>
      <Switch bind:checked={route.hide} aria-labelledby="hide-label" />
    </div>
    <div class="section" aria-labelledby="header-label">
      <p id="header-label">
        {$format('label.TOP_PLACEMENT')}
        <Icon name="help-circle" id="tooltip-route-header" />
        <Tooltip target="tooltip-route-header" placement="top">
          {$format('label.TOOLTIP.ROUTE_TOP_PLACEMENT')}
        </Tooltip>
      </p>
      <Switch bind:checked={route.header} aria-labelledby="header-label" />
    </div>
  </ShowMore>
</div>

<style lang="scss">
  .signature-route-form {
    .section {
      p {
        font-weight: var(--font-weight-medium);
        margin-bottom: var(--margin-base);
      }

      + .section {
        margin-top: var(--margin-large);
      }

      .empty {
        color: var(--color-gray-600);
        padding: var(--padding-xlarge);
        text-align: center;
      }
    }

    hr {
      margin: var(--margin-large) 0;
    }
  }
</style>
